import axios from '@/libs/api.request'
import config from '@/config'

// 数据库管理基础URL
const dbBaseUrl = config.baseDBUrl + '/database/api/v1/'

export const getAllInstance = (params) => {
  return axios.request({
    url: dbBaseUrl + 'all_instance/',
    params: params,
    method: 'get'
  })
}

export const detailInstance = (id, params) => {
  return axios.request({
    url: dbBaseUrl + 'all_instance/' + id + '/',
    params: params,
    method: 'get'
  })
}

export const InstanceReViewSql = (data) => {
  return axios.request({
    url: dbBaseUrl + 'review_sql/',
    data: data,
    method: 'post'
  })
}
